import { render, staticRenderFns } from "./SidebarMini.vue?vue&type=template&id=2249894b&"
import script from "./SidebarMini.vue?vue&type=script&lang=js&"
export * from "./SidebarMini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports